import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=535f9be8&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&id=535f9be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f9be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535f9be8')) {
      api.createRecord('535f9be8', component.options)
    } else {
      api.reload('535f9be8', component.options)
    }
    module.hot.accept("./transactions.vue?vue&type=template&id=535f9be8&scoped=true&", function () {
      api.rerender('535f9be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/transactions.vue"
export default component.exports